import React from 'react';

/**
 * Reusable display of an equipment cell:
 *   EQUIPMENT-CODE
 *   [Category badge] Description ? Brand Model
 */
export const EquipmentCell = ({ vehicle, showDescription = true }) => {
  if (!vehicle) return <span className="text-slate-400 text-xs">—</span>;
  const descParts = [vehicle.brand || vehicle.make, vehicle.model].filter(Boolean).join(' ');
  return (
    <div className="space-y-1">
      <div className="font-mono font-semibold text-sm leading-tight">{vehicle.equipment_code || '—'}</div>
      <div className="flex flex-wrap items-center gap-1.5">
        {vehicle.category && (
          <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-blue-50 text-[hsl(217,91%,24%)] border border-blue-200 text-[10px] font-medium leading-none">
            {vehicle.category}
          </span>
        )}
        {showDescription && (vehicle.description || descParts) && (
          <span className="text-xs text-slate-500 truncate">{vehicle.description || descParts}</span>
        )}
      </div>
    </div>
  );
};

/**
 * Compact one-line option for select dropdowns.
 */
export const EquipmentOptionLabel = ({ vehicle }) => {
  if (!vehicle) return null;
  const desc = vehicle.description || [vehicle.brand || vehicle.make, vehicle.model].filter(Boolean).join(' ');
  return (
    <span className="flex items-center gap-2">
      <span className="font-mono font-semibold">{vehicle.equipment_code}</span>
      {vehicle.category && <span className="text-[10px] px-1.5 py-0.5 rounded bg-blue-50 text-[hsl(217,91%,24%)] border border-blue-200">{vehicle.category}</span>}
      {desc && <span className="text-slate-500 truncate">— {desc}</span>}
    </span>
  );
};

export default EquipmentCell;
